import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import feed from './modules/feed'
import question from './modules/question'
import influencer from './modules/influencer'
import subscription from './modules/subscription'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    feed,
    question,
    influencer,
    subscription,
  },
  state: {
    controls: {
      showDrawer: true,
    },
  },
  mutations: {
    toggleDrawer(state, value) {
      state.controls.showDrawer = value
    },
  },
})
